// extracted by mini-css-extract-plugin
module.exports = {"programmesList":"ProgrammesList_programmesList__1-q43","footer":"ProgrammesList_footer__2K-VC"};